import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import IngredientSlots from './components/IngredientSlots';
import AffectedRecipesNotice from './components/AffectedRecipesNotice';
import ApiService from '../services/ApiService';
import { useAuth } from '../context/auth';
const api = new ApiService();

const MachineIngredient = (props) => {
	const { machineId } = props.location.state ? props.location.state : '';
	const { authTokens } = useAuth();
	const headers = { 'X-Firebase-Auth-Client': authTokens.token };
	const [alertSaveChanges, setAlertSaveChanges] = useState(false);

	const [all, setAll] = useState([]);
	const [allIncludingInMachine, setAllIncludingInMachine] = useState([]);
	const [affectedRecipesByChange, setAffectedRecipesByChange] = useState([]);
	const [oldIngredientName, setOldIngredientName] = useState('');
	const [newIngredientName, setNewIngredientName] = useState('');
	const [machineIngredients, setMachineIngredients] = useState([]);
	const [currentMachineRecipes, setCurrentMachineRecipes] = useState(
		props.location.state ? props.location.state.recipes : [],
	);
	const [ingredientsOptions, setIngredientsOptions] = useState([]);
	const [cartridgeOptions, setCartridgeOptions] = useState([
		{ key: '1', value: 0, text: '1', updatedHighlight: false },
		{ key: '2', value: 1, text: '2', updatedHighlight: false },
		{ key: '3', value: 2, text: '3', updatedHighlight: false },
		{ key: '4', value: 3, text: '4', updatedHighlight: false },
		{ key: '5', value: 4, text: '5', updatedHighlight: false },
		{ key: '6', value: 5, text: '6', updatedHighlight: false },
		{ key: '7', value: 6, text: '7', updatedHighlight: false },
		{ key: '8', value: 7, text: '8', updatedHighlight: false },
		{ key: '9', value: 8, text: '9', updatedHighlight: false },
		{ key: '10', value: 9, text: '10', updatedHighlight: false },
	]);
	const [changeIngredientTo, setChangeIngredientTo] = useState([
		{ key: 1, from: {}, to: {}, changed: false },
		{ key: 2, from: {}, to: {}, changed: false },
		{ key: 3, from: {}, to: {}, changed: false },
		{ key: 4, from: {}, to: {}, changed: false },
		{ key: 5, from: {}, to: {}, changed: false },
		{ key: 6, from: {}, to: {}, changed: false },
		{ key: 7, from: {}, to: {}, changed: false },
		{ key: 8, from: {}, to: {}, changed: false },
		{ key: 9, from: {}, to: {}, changed: false },
		{ key: 10, from: {}, to: {}, changed: false },
	]);

	const [machineRecipesId, setMachineRecipesId] = useState([]); // array of recipe ids
	const [allRecipes, setAllRecipes] = useState([]); // array of all recipes

	const toast = useRef(null);
	const unsavedToastShown = useRef(false);

	useEffect(() => {
		const headers = {
			'X-Firebase-Auth-Client': authTokens.token,
		};

		const getMachineRecipesByMachineId = async () => {
			const response = await api.getMachineRecipes(machineId, headers);
			setMachineRecipesId(response.data);
			console.log('machineRecipesId', response.data);
		};

		const getAllRecipes = async () => {
			const response = await api.getAllMachineRecipesWithoutPagination(headers);
			setAllRecipes(response.data.recipes);
			console.log('allRecipes', response.data.recipes);
		};

		getMachineRecipesByMachineId();
		getAllRecipes();
	}, [authTokens.token, machineId]);

	useEffect(() => {
		if (
			!Array.isArray(machineRecipesId) ||
			!Array.isArray(allRecipes) ||
			machineRecipesId.length === 0 ||
			allRecipes.length === 0
		) {
			return;
		}

		// find the recipe object for each recipe id and add it to the machineRecipes array and add the index
		const result = machineRecipesId.map((recipe) => {
			const recipeObj = allRecipes.find((r) => r.id === recipe.recipeId);
			return {
				...recipeObj,
				index: recipe.index,
			};
		});

		// sort the machineRecipes array by index
		result.sort((a, b) => a.index - b.index);

		console.log('result', result);
		setCurrentMachineRecipes(result);
	}, [machineRecipesId, allRecipes]);

	// effects are declared after callbacks are defined

	const fetchIngredientsState = useCallback(async () => {
		if (allIncludingInMachine.length === 0) return;
		try {
			const arrayOfIngredientsState = await api.getStateIngredientsInMachine(machineId, {
				'X-Firebase-Auth-Client': authTokens.token,
			});

			// this array looks like this
			/**
			 * [
			 * {available: true, enabled: true, compartment: 1, ingredientId: '23702cda-ec65-4f1c-9861-f2f5ee099db0', customConfig: false}
			 * {available: true, enabled: true, compartment: 2, ingredientId: '5414ae69-b4bf-4206-8ec5-f17b54a3b4ac', customConfig: false}
			 * ]
			 */

			// Build fresh ingredient objects per slot (avoid shared references)
			const ingredientsInMachine = arrayOfIngredientsState.data.map((state) => {
				const ingredientObj = allIncludingInMachine.find((ingredient) => ingredient.id === state.ingredientId);
				if (!ingredientObj) return ingredientObj;
				return {
					...ingredientObj,
					flavor: ingredientObj.flavor ? { ...ingredientObj.flavor } : undefined,
					available: state.available,
					enabled: state.enabled,
					compartment: state.compartment,
					customConfig: state.customConfig,
				};
			});

			// sort the ingredients by compartment
			ingredientsInMachine.sort((a, b) => {
				return a.compartment - b.compartment;
			});

			setMachineIngredients(ingredientsInMachine);
		} catch (error) {
			console.error(error);
		}
	}, [allIncludingInMachine, machineId, authTokens.token]);

	const fetchIngredients = useCallback(async () => {
		try {
			const result = await api.getAllIngredients({ 'X-Firebase-Auth-Client': authTokens.token });
			const ingredientsData = result.data;

			// set all ingredients including in machine
			setAllIncludingInMachine(ingredientsData);
			setAll(ingredientsData);

			// create options for dropdown from ALL ingredients (PrimeReact default shape)
			const options = ingredientsData.map((ingredient) => {
				return { label: ingredient.name, value: ingredient.id };
			});
			setIngredientsOptions(options);
		} catch (error) {
			console.error(error);
		}
	}, [authTokens.token]);

	useEffect(() => {
		fetchIngredients();
	}, [fetchIngredients]);

	useEffect(() => {
		fetchIngredientsState();
	}, [fetchIngredientsState]);

	const updateIngredients = async () => {
		try {
			await api.updateMachineIngredients(machineId, machineIngredients, headers);

			fetchIngredients();
			fetchIngredientsState();

			setAlertSaveChanges(false);
			unsavedToastShown.current = false;

			// reset the changeIngredientTo array
			setChangeIngredientTo(
				changeIngredientTo.map((changeIngredient) => {
					return { ...changeIngredient, from: {}, to: {}, changed: false };
				}),
			);

			// reset the cartridge options
			setCartridgeOptions(
				cartridgeOptions.map((cartridgeOption) => {
					return { ...cartridgeOption, updatedHighlight: false };
				}),
			);

			// success toast
			if (toast.current) {
				toast.current.show({
					severity: 'success',
					summary: 'Success',
					detail: 'Ingredients updated successfully!',
					life: 3000,
				});
			}
		} catch (error) {
			console.error(error);
			// error toast
			if (toast.current) {
				toast.current.show({
					severity: 'error',
					summary: 'Failed',
					detail: 'Ingredients failed to update!',
					life: 4000,
				});
			}
		}
	};

	const changeEnabled = (index) => {
		setAlertSaveChanges(true);
		const tempIngredients = machineIngredients.slice();
		tempIngredients[index].enabled = !tempIngredients[index].enabled;
		setMachineIngredients(tempIngredients);
	};
	const changeCustomConfig = (index) => {
		setAlertSaveChanges(true);
		const tempIngredients = machineIngredients.slice();
		tempIngredients[index].customConfig = !tempIngredients[index].customConfig;
		setMachineIngredients(tempIngredients);
	};

	const onChangeDropDownIngredient = (slotIndex, selectedId, oldIngredient) => {
		setAlertSaveChanges(true);

		// find selected ingredient from the complete list
		const newIngredient = all.find((ingredient) => {
			return ingredient.id === selectedId;
		});
		if (!newIngredient) {
			return;
		}

		// update the changeIngredientTo array with the new ingredient
		setChangeIngredientTo(
			changeIngredientTo.map((changeIngredient) => {
				if (changeIngredient.key === slotIndex + 1) {
					// update array with the old and new ingredient and set changed to true
					return { ...changeIngredient, from: oldIngredient, to: newIngredient, changed: true };
				}
				return changeIngredient;
			}),
		);

		// update machine ingredients by compartment index instead of by name (allows duplicates)
		setMachineIngredients((prev) => {
			const next = prev.slice();
			const idx = slotIndex;
			const prevItem = next[idx];

			// Create a deep copy to avoid shared object references
			const selectedIngredient = {
				...newIngredient,
				flavor: { ...newIngredient.flavor },
				available: prevItem?.available ?? true,
				enabled: prevItem?.enabled ?? true,
				compartment: idx,
				customConfig: prevItem?.customConfig ?? false,
			};

			next[idx] = selectedIngredient;
			return next;
		});

		// set names for affected recipes message
		setNewIngredientName(newIngredient.name);
		setOldIngredientName(oldIngredient.name);

		// set updated highlight to true for the cartridge
		setCartridgeOptions(
			cartridgeOptions.map((cartridgeOption) => {
				if (cartridgeOption.value === slotIndex) {
					return { ...cartridgeOption, updatedHighlight: true };
				}
				return cartridgeOption;
			}),
		);

		// show user by changing indredients which machine recipes will be affected
		updateAffectedRecipes(oldIngredient);
	};

	useEffect(() => {
		if (alertSaveChanges && !unsavedToastShown.current) {
			if (toast.current) {
				toast.current.show({
					severity: 'info',
					summary: 'Unsaved changes',
					detail: "Don't forget to save your changes!",
					life: 10000, // 10 seconds
				});
			}
			unsavedToastShown.current = true;
		}
		if (!alertSaveChanges) {
			unsavedToastShown.current = false;
		}
	}, [alertSaveChanges]);

	const updateAffectedRecipes = (oldIngredient) => {
		if (currentMachineRecipes !== undefined) {
			const affectedRecipes = currentMachineRecipes.filter((recipe) => {
				return recipe.smoothieParts.some((ingredient) => ingredient.flavor.name === oldIngredient.name);
			});

			setAffectedRecipesByChange(affectedRecipes);
		}
	};

	return (
		<div className="p-3 pt-0 machine-detail-page">
			<Toast ref={toast} />
			{affectedRecipesByChange.length > 0 && (
				<AffectedRecipesNotice
					oldIngredientName={oldIngredientName}
					newIngredientName={newIngredientName}
					recipes={affectedRecipesByChange}
				/>
			)}

			<IngredientSlots
				cartridgeOptions={cartridgeOptions}
				machineIngredients={machineIngredients}
				changeIngredientTo={changeIngredientTo}
				ingredientsOptions={ingredientsOptions}
				onDropdownClick={fetchIngredients}
				onIngredientChange={onChangeDropDownIngredient}
				onToggleEnabled={changeEnabled}
				onToggleCustomConfig={changeCustomConfig}
			/>

			<div className="flex justify-content-end pt-2">
				<Button label="Save" icon="pi pi-save" onClick={updateIngredients} />
			</div>
		</div>
	);
};

export default MachineIngredient;
